import React from 'react';

export default function PlaceholderChart({ title, note }) {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div style={{ height: '180px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                {note || 'Chart placeholder'}
            </div>
        </div>
    );
}


